import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './shared/guards/auth.guard';
import { LoginComponent } from './pages/login/login.component';
import { HomeComponent } from './pages/home/home.component';
import { RouteComponent } from './pages/route/route.component';


const routes: Routes = [
  {
    path: '',
    redirectTo: '/result/error',
    pathMatch: 'full'
  },
  {
    path: 'home/:id',
    component: HomeComponent
  },
  {
    path: 'route/:trackingId',
    component: RouteComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'second-login/:trackingId',
    component: LoginComponent
  },
  {
    path: 'notification',
    loadChildren: () => import('./shared/notification/notification.module').then(m => m.NotificationModule)
  },
  {
    path: 'sign-up',
    loadChildren: () => import('./pages/signup/signup.module').then(m => m.SignupModule)
  },
  {
    path: 'payment',
    loadChildren: () => import('./pages/payment/payment.module').then(m => m.PaymentModule)
  },
  {
    path: 'payment',
    loadChildren: () => import('./pages/payment/payment.module').then(m => m.PaymentModule)
  },
  {
    path: 'result',
    loadChildren: () => import('./pages/result/result.module').then(m => m.ResultModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/phone-login/phone-login.module').then(m => m.PhoneLoginModule)
  },
  {
    path: '**',
    redirectTo: '/result/error',
    pathMatch: 'full'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
